import React, { Component } from 'react'
import './ad.less'
const adParam = {
  p: '', // 广告id
  s: '', // showid
  sid: '', // pvid
  aw: 'w',
  k: '', // showid_en
  rst: 'h5,img'
}

/**
 * data.adType 0 - 普通通栏广告
 * data.adType 1 - 浮层广告
 * props.showType 展示类型  tabheader - 抽屉导航标题广告
 */
export default class AdComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isChecked: false
    }
    this.initAdSDK()
  }

  requestAD (op) {
    if (!op.id) return
    const userAgent = navigator.userAgent.toLowerCase()
    const param = adParam
    param.p = op.id
    param.ios = (userAgent.indexOf('mac') !== -1 || userAgent.indexOf('ios') !== -1)
    param.compatible = 1
  }

  initAdSDK () {
    if (typeof window !== 'undefined' && !window._adSDK) {
      if (window.adPageSDK) {
        const ADPageSDK = window.adPageSDK
        window._adSDK = new ADPageSDK()
      }
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    return false
  }

  componentDidMount () {
    if (window._adSDK) {
      window._adSDK.check(this.refs.bdom.parentElement)
    }
  }

  render () {
    const _className = this.props.data.adType === 0 ? 'ad-wrap' : ''
    const data = {
      id: `ab_${this.props.data.adId}`,
      ref: 'bdom',
      'data-areaid': this.props.headerId,
      'data-adpid': this.props.data.adId,
      'data-adid': this.props.data.adId,
      'data-adtype': this.props.showType ? this.props.showType : ''
    }
    return (
      this.props.showType === 'tabheader' ? <div className={this.props.className}><div className={_className} {...data} /></div>
        : <div className={_className} {...data} />
    )
  }
}
